module.exports = __webpack_public_path__ + "img/flags/KH.5989492.png";